// extracted by extract-css-chunks-webpack-plugin
module.exports = {"category":"app-components-staticpages-blocks-heroarticleblock--category"};